var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyDetailsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30058_12016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9355 32.314V15.064C24.9355 14.9283 24.8986 14.7951 24.8287 14.6787C24.7589 14.5623 24.6588 14.467 24.5391 14.403C24.4194 14.339 24.2846 14.3087 24.149 14.3153C24.0134 14.322 23.8822 14.3652 23.7693 14.4406L16.2693 19.4403C16.1664 19.5089 16.0821 19.6019 16.0239 19.711C15.9657 19.8201 15.9353 19.9419 15.9355 20.0656V32.314",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9355 20.3145H31.6855C31.8845 20.3145 32.0752 20.3935 32.2159 20.5341C32.3565 20.6748 32.4355 20.8655 32.4355 21.0645V32.3145",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6855 32.3145H34.6855",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9355 22.5645V24.0645",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9355 22.5645V24.0645",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9355 27.8145V29.3145",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9355 27.8145V29.3145",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30058_12016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.1855 12.0645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetailsActive);
export default __webpack_public_path__ + "static/media/companyDetailsActive.cd7fc2ea7153e97c107fe3fba1c5c6cd.svg";
export { ForwardRef as ReactComponent };